import { render, staticRenderFns } from "./ModattaCreditCard.vue?vue&type=template&id=27ddb8ed"
import script from "./ModattaCreditCard.vue?vue&type=script&lang=js"
export * from "./ModattaCreditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports